<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="consultation_patients"
      endpoint="/consultationpatients"
      action-path="/treatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Consultation Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Consultation Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Consultation Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Consultation Patients", active: true }],
    };
  },
};
</script>
